// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import React from 'react';
import PropTypes from 'prop-types';
import { Button, Stack, Download02Icon } from '@metarouter-private/mr-mui';

export default function ModalActions({
  isProcessing,
  isComplete,
  canUpload,
  onCancel,
  onUpload,
  onClose,
  onDownloadReport,
}) {
  if (isComplete) {
    return (
      <Stack direction="row" spacing={1}>
        <Button onClick={onClose} color="secondary" variant="outlined">
          Close
        </Button>
        <Button onClick={onDownloadReport} variant="contained" startIcon={<Download02Icon />}>
          Download Report
        </Button>
      </Stack>
    );
  }

  if (isProcessing) {
    return (
      <Stack direction="row" spacing={1}>
        <Button onClick={onCancel} color="secondary" variant="outlined" disabled>
          Cancel
        </Button>
        <Button disabled variant="outlined">
          Processing...
        </Button>
      </Stack>
    );
  }

  return (
    <Stack direction="row" spacing={1}>
      <Button onClick={onCancel} color="secondary" variant="outlined">
        Cancel
      </Button>
      <Button onClick={onUpload} variant="contained" disabled={!canUpload} data-test-id="bulk-upload-submit-button">
        Upload
      </Button>
    </Stack>
  );
}

ModalActions.propTypes = {
  isProcessing: PropTypes.bool.isRequired,
  isComplete: PropTypes.bool.isRequired,
  canUpload: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onUpload: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onDownloadReport: PropTypes.func,
};
